const toPixel = (v: number) => `${v}px`;

export const transformers = {
  radii: toPixel,
};
